var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.paymentStatus},[_c('div',{class:[_vm.$style.circle, _vm.color]}),_c('div',{class:_vm.$style.text},[_vm._v(" "+_vm._s(_vm.status)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }